<template>
    <div class="row gx-3">
        <pc-label
            v-bind:label="label"
            v-bind:for-id="inputId"
            v-bind:show-required="required"
            v-bind:show-help="showHelp"
            v-bind:help-link="showHelpLinkOnly"
            class="col-12"
            v-on:help-clicked="emitHelpClicked" />
        <div class="col-12">
            <slot name="help" />
        </div>
        <pc-input-group v-bind:class="responsiveHelpers.short">
            <pc-input
                v-bind:validation-group-id="inputId"
                v-bind="binder"
                inputmode="numeric"
                data-test-role="textbox-element"
                v-on="listeners" />
        </pc-input-group>
        <validation-render-helper
            v-bind:validation-error="validationError"
            v-bind:validation-group-id="inputId" />
    </div>
</template>

<script>
    import base, { VALIDATOR_TYPES, validationRenderHelper } from "./_elementBase";

    export default {
        components: { validationRenderHelper },
        extends: base,
        methods: {
            getAdditionalValidatorOptions() {
                const useThousandSeparatorFormatter = Boolean(this.dataField && this.dataField.ShowSeparators);
                const validatorOptions = [VALIDATOR_TYPES.integer];
                const min = this.getNumericPropertyValue("min");
                if (min != null) {
                    validatorOptions.push({ type: VALIDATOR_TYPES.min, min, useThousandSeparatorFormatter });
                }

                const max = this.getNumericPropertyValue("max");
                if (max != null) {
                    validatorOptions.push({ type: VALIDATOR_TYPES.max, max, useThousandSeparatorFormatter });
                }
                return validatorOptions;
            }
        }
    };
</script>
